import { useState } from "react";
import { useData } from "@/context/DataContext";
import { BRAND } from "@/constants/brand";

const GLOWS = ["neon", "neon-pink", "neon-red"];
const ARTS = [
  BRAND.photos.lemonSplash,
  BRAND.photos.graffitiTags,
  BRAND.photos.lemonPurple,
  BRAND.photos.graffitiColor,
  BRAND.photos.jarWall,
];

export const RecipesTab = () => {
  const { content } = useData();
  const recipes = content.recipes || [];
  const [openId, setOpenId] = useState(recipes[0]?.id);
  const categories = [...new Set(recipes.map((r) => r.category))];

  return (
    <div className="space-y-6" data-testid="recipes-tab">
      <div className="relative overflow-hidden rounded-sm border border-border">
        <div
          className="h-32 photo-band md:h-40"
          style={{ backgroundImage: `url(${BRAND.photos.lips})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]/40" />
        <div className="absolute inset-0 flex flex-col justify-center px-6">
          <h3 className="display neon text-3xl md:text-4xl">Drinks 411</h3>
          <p className="mono w-fit bg-[#0A0A0A]/85 px-1.5 py-0.5 text-[10px] tracking-widest text-white">
            CONFIDENTIAL — SMASH LEMONADE PROPERTY
          </p>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-3">
        <div className="space-y-5 lg:col-span-1">
          {categories.map((cat) => (
            <div key={cat}>
              <div className="mono text-[10px] tracking-[0.3em] text-primary">
                {cat.toUpperCase()}
              </div>
              <div className="mt-2 space-y-2">
                {recipes
                  .filter((r) => r.category === cat)
                  .map((r) => (
                    <button
                      key={r.id}
                      data-testid={`recipe-select-${r.id}`}
                      onClick={() => setOpenId(r.id)}
                      className={`flex w-full items-center gap-3 border rounded-sm px-3 py-2 text-left transition-all hover:-translate-y-0.5 ${
                        openId === r.id
                          ? "border-primary bg-[#191603]"
                          : "border-border bg-[#141414] hover:border-primary/60"
                      }`}
                    >
                      {r.image ? (
                        <img
                          src={r.image}
                          alt=""
                          loading="lazy"
                          className="h-11 w-11 shrink-0 object-contain"
                        />
                      ) : null}
                      <span className="min-w-0">
                        <span className="display block text-lg leading-tight">{r.name}</span>
                        <span className="mono block text-[10px] tracking-widest text-muted-foreground">
                          {r.cupSize}
                        </span>
                      </span>
                    </button>
                  ))}
              </div>
            </div>
          ))}
          {recipes.length === 0 && (
            <p className="text-sm text-muted-foreground">
              No recipes yet. Smash HQ has to load the vault.
            </p>
          )}
        </div>

        <div className="lg:col-span-2">
          {recipes
            .filter((r) => r.id === openId)
            .map((r) => {
              const idx = recipes.findIndex((x) => x.id === r.id);
              return (
                <div
                  key={r.id}
                  className="relative overflow-hidden rounded-sm border border-border fade-up"
                  data-testid="recipe-detail"
                >
                  <div
                    className="absolute inset-0 photo-band opacity-30"
                    style={{ backgroundImage: `url(${ARTS[idx % ARTS.length]})` }}
                  />
                  <div className="absolute inset-0 bg-[#0A0A0A]/88" />
                  <div className="relative grid gap-6 p-6 md:grid-cols-[1fr_auto] md:p-8">
                    <div>
                      <h3 className={`display ${GLOWS[idx % GLOWS.length]} text-4xl md:text-5xl`}>
                        {r.name}
                      </h3>
                      <div className="mono text-[11px] tracking-widest text-primary">
                        {r.category} · {r.cupSize}
                      </div>
                      <div className="mt-6">
                        <div className="mono text-[11px] tracking-widest text-muted-foreground">
                          BUILD
                        </div>
                        <pre className="mt-2 whitespace-pre-wrap font-sans text-lg font-bold leading-relaxed">
                          {r.ingredients}
                        </pre>
                      </div>
                      <div className="mt-6">
                        <div className="mono text-[11px] tracking-widest text-muted-foreground">
                          FINISH
                        </div>
                        <pre className="mt-2 whitespace-pre-wrap font-sans text-base leading-relaxed text-muted-foreground">
                          {r.procedure}
                        </pre>
                      </div>
                      {r.notes && (
                        <div className="mt-6 border-l-2 border-primary pl-3 text-xs text-muted-foreground">
                          {r.notes}
                        </div>
                      )}
                    </div>
                    {r.image ? (
                      <img
                        src={r.image}
                        alt={r.name}
                        data-testid="recipe-cup-photo"
                        className="mx-auto max-h-72 self-end object-contain drop-shadow-[0_10px_30px_rgba(0,0,0,0.8)] md:max-h-96"
                      />
                    ) : null}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};
